import { React }  from "react";
import "./ConfirmationModal.css";

/**
 * Modular confirmation modal component
 * @param {*} onClose - Function to close the modal
 * @param {*} onConfirm - Function to confirm the action, example: function to delete shelf
 * @param {*} title - Title of the modal
 * @param {*} message - Message to display in the modal
 * @returns 
 */
function ConfirmationModal( {onClose, onConfirm, title, message} ) {

  return (
    <div className="modal-overlay">
      <div className="confirmation-modal">
        <h2 className="modal-header">{title}</h2>
        <p className='confirmation-message'>{message}</p>
        <button onClick={onConfirm} className='important-button'>Confirm</button>
        <button onClick={() => onClose(false)} className='secondary-button'>Cancel</button>
      </div>
    </div>
  );
}

export default ConfirmationModal;
